import { Component, OnInit } from "@angular/core";
import { ToastService } from "src/app/shared/toast.service";
import { InsertBuilding } from "../models/InsertBuilding";
import { LomImportService } from "../services/lom-import.service";
import { Area } from "src/app/shared/Models/read";
import { ImportType } from "../models/ImportType.enum";
import { InsertAddress } from "../models/insertAddress";

@Component({
  selector: "app-import-buildings",
  templateUrl: "./import-buildings.component.html",
  styleUrls: ["./import-buildings.component.scss"],
  providers: [ToastService],
})
export class ImportBuildingsComponent implements OnInit {
  values: string[] = [];
  block: Area;
  fiberhood: Area;
  selectedType: ImportType;
  inputTitle: string;
  inputDetails: string;

  importTypes = [
    {
      label: ImportType[ImportType.building],
      value: ImportType.building,
    },
    {
      label: ImportType[ImportType.address],
      value: ImportType.address,
    },
  ];
  constructor(
    private toastService: ToastService,
    private lomImportService: LomImportService
  ) {}
  ngOnInit(): void {
    this.getFiberhoodData();
    this.getBlockData();
    this.setImportValuesTexts();
  }

  onBlockUpdated(selectedBlock: Area) {
    this.block = selectedBlock;
    sessionStorage.setItem("block", JSON.stringify(this.block));
  }

  onFiberhoodUpdated(selectedFiberhood: Area) {
    this.fiberhood = selectedFiberhood;
    sessionStorage.setItem("fiberhood", JSON.stringify(this.fiberhood));
  }

  submit() {
    var errorMessage = this.validate();
    if (errorMessage) {
      this.toastService.showErrorToast(
        $localize`Something went wrong`,
        errorMessage
      );
      return;
    }

    if (this.selectedType === ImportType.building)
      this.lomImportService
        .executeBuildingLomImport(
          new InsertBuilding(this.values, this.block.id)
        )
        .subscribe((_) => {
          this.values = [];
        });
    else if (this.selectedType === ImportType.address)
      this.lomImportService
        .executeAddressLomImport(new InsertAddress(this.values, this.block.id))
        .subscribe((_) => {
          this.values = [];
        });
  }

  canSubmit() {
    if (
      this.selectedType === ImportType.building ||
      this.selectedType === ImportType.address
    )
      return this.values.length > 0 && this.block != null;
  }

  setImportValuesTexts() {
    this.inputTitle = this.lomImportService.getImportTitleText(
      this.selectedType
    );
    this.inputDetails = this.lomImportService.getImportDetailText(
      this.selectedType
    );
  }

  private validate(): string {
    if (
      (this.selectedType === ImportType.building ||
        this.selectedType === ImportType.address) &&
      !this.block
    )
      return $localize`Select what block you want to upload to.`;
    if (this.values.length == 0)
      return $localize`Please enter at least one key`;
    if (this.values.some((l) => Number.isNaN(Number(l))))
      return $localize`One of the entered keys was of an invalid format`;
    return null;
  }

  private getBlockData() {
    if (
      sessionStorage.getItem("block") &&
      sessionStorage.getItem("block") != "null"
    )
      this.block = JSON.parse(sessionStorage.getItem("block"));
  }

  private getFiberhoodData() {
    if (
      sessionStorage.getItem("fiberhood") &&
      sessionStorage.getItem("fiberhood") != "null"
    )
      this.fiberhood = JSON.parse(sessionStorage.getItem("fiberhood"));
  }
}
